// extracted by mini-css-extract-plugin
export default {"title":"Offerings_title__nmX+W","content":"Offerings_content__hqm7r","itemName":"Offerings_itemName__DeDan"};